import { AlertTitle } from "@mui/material"
import { ReactElement } from "react"

import { SUPPORT_REFER_ENTITY } from "../../../../errors/errorMessages"
import AppAlert from "../../../dataDisplay/alerts/appAlert"

const alertMessage =
    `Connect Direct is having an issue meaning it is unable to display this input. ` +
    `Please report this ASAP to ${SUPPORT_REFER_ENTITY}`

interface IInputNotFoundProps {
    inputName: string
}

/**
 * Displays an alert when an input is not found in the input type map
 *
 * @param inputName Name of the input that was not found
 * @returns Alert with error message
 */
const InputNotFound = ({ inputName }: IInputNotFoundProps): ReactElement => (
    <AppAlert severity="error">
        <AlertTitle>{`There was an issue displaying the input: ${inputName}`}</AlertTitle>
        {alertMessage}
    </AppAlert>
)

export default InputNotFound
